import { FC, useMemo, useState } from "react";
import Start from "./Start";
import ConfirmCode from "./ConfirmCode";
import Loading from "./Loading";
import GoodScore from "./Good";
import BadScore from "./Bad";

const creditScoreSteps = {
  start: "start",
  loading: "loading",
  otp: "otp",
  good: "good",
  bad: "bad",
} as const;

type Steps = keyof typeof creditScoreSteps;

interface CreditScoreProps {
  trackingCode: string;
  afterSuccess: () => void;
}
const PayGetOrderCreditScore: FC<CreditScoreProps> = ({ afterSuccess, trackingCode }) => {
  const [step, setStep] = useState<Steps>(creditScoreSteps.start);
  const [description, setDescription] = useState("");

  const fakeFinish = () => {
    setDescription("ریسک متوسط");
    setStep(creditScoreSteps.good);
  };

  const currentStep = useMemo(() => {
    if (creditScoreSteps.loading === step) {
      return (
        <Loading
          trackingCode={trackingCode}
          goodFinish={(ds) => {
            setDescription(ds);
            setStep(creditScoreSteps.good);
          }}
          badFinish={(ds) => {
            setDescription(ds);
            setStep(creditScoreSteps.bad);
          }}
          unknownFinish={() => {
            fakeFinish();
          }}
        />
      );
    }
    if (creditScoreSteps.otp === step) {
      return (
        <ConfirmCode
          onFinish={() => {
            setStep(creditScoreSteps.loading);
          }}
          trackingCode={trackingCode}
          unknownFinish={() => {
            fakeFinish();
          }}
        />
      );
    }
    if (creditScoreSteps.good === step) {
      return (
        <GoodScore
          description={description}
          onFinish={() => {
            afterSuccess();
          }}
        />
      );
    }
    if (creditScoreSteps.bad === step) {
      return <BadScore description={description} />;
    }
    return (
      <Start
        trackingCode={trackingCode}
        onFinish={() => {
          setStep(creditScoreSteps.otp);
        }}
        unknownFinish={() => {
          fakeFinish();
        }}
      />
    );
  }, [afterSuccess, description, step, trackingCode]);

  return currentStep;
};

export default PayGetOrderCreditScore;
